import type { Editor, NodeEntry } from 'slate';
import { Transforms } from 'slate';

import { mergeWithDefaults } from '../../../util';
import type { HeaderElement } from '../../internal';
import { createDefaultHeaderByType } from '../../internal';

export function normalizeHeader(editor: Editor, headerEntry: NodeEntry<HeaderElement>): void {
  validateHeaderProps(editor, headerEntry);
}

function validateHeaderProps(editor: Editor, headerEntry: NodeEntry<HeaderElement>): void {
  const [header, headerPath] = headerEntry;
  const { children: headerChildren, ...headerProps } = header;
  const { children: defaultHeaderChildren, ...defaultHeaderProps } = createDefaultHeaderByType(
    header.type
  );
  const missingKeys = Object.keys(defaultHeaderProps).some(propKey => {
    const hasKey = propKey in header;
    return !hasKey;
  });
  const newProps: Omit<HeaderElement, 'children'> = mergeWithDefaults(
    headerProps,
    defaultHeaderProps
  );
  if (!missingKeys) return;

  Transforms.setNodes(editor, newProps, { at: headerPath });
}
